import { render, staticRenderFns } from "./viewCurrencyExchange.vue?vue&type=template&id=12d72bd8&scoped=true&"
import script from "./viewCurrencyExchange.vue?vue&type=script&lang=js&"
export * from "./viewCurrencyExchange.vue?vue&type=script&lang=js&"
import style0 from "./viewCurrencyExchange.vue?vue&type=style&index=0&id=12d72bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d72bd8",
  null
  
)

export default component.exports